import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-2.5" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "w-full" }

import { ListFilterButtonVariant } from '@/enums/list-filter';
import { NotificationType } from '@/enums/notification';
import { useFavoritesStore } from '@/stores/favorites';
import { useLocationStore } from '@/stores/location';
import { TranslateKey, useInject } from '@/composables/use-inject';
import { UseNotificationReturn, useNotification } from '@/composables/use-notification';
import ListFilterButton from '@/components/ListFilter/ListFilterButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemFavoritesActions',
  setup(__props) {

const translate = useInject(TranslateKey);
const locationStore = useLocationStore();
const favoritesStore = useFavoritesStore();
const notification: UseNotificationReturn = useNotification();

const addToFavorites = (): void => {
  if (!locationStore.getSearchWord) {
    notification.show(NotificationType.ERROR, 'notification.errorCurrentPage');
    return;
  }

  if (favoritesStore.getFavorite(locationStore.getSearchWord)) {
    notification.show(NotificationType.ERROR, 'notification.errorRegistered');
    return;
  }

  favoritesStore.addFavorite(locationStore.getSearchWord);
};

const removeAllFavorites = (): void => {
  favoritesStore.removeFavorites();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListFilterButton, {
        variant: _unref(ListFilterButtonVariant).LIGHT,
        onClick: addToFavorites
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(translate)('itemFavorites.listToFavorites')), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ListFilterButton, {
        variant: _unref(ListFilterButtonVariant).LIGHT,
        onClick: removeAllFavorites
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(translate)('itemFavorites.allReset')), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ])
  ]))
}
}

})